import React from "react";
import PropTypes from "prop-types";

import styles from "./atoms.Tooltip.module.scss";
export const Tooltip = ({ content, text, position }) => {
  return (
    <div
      className={`${styles["main-app-tooltip"]} ${
        position ? styles[position] : ""
      }`}
    >
      {content}
      {text && (
        <div
          className={`${styles["tooltip-text"]} ${
            position ? styles[position] : ""
          }`}
        >
          {text}
        </div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  handleClick: PropTypes.func,
  legend: PropTypes.string
};

export default Tooltip;
